import { Spin } from "components/atoms/Spin"
import { NotFound } from "components/molecules/404"
import { RecruitListView } from "components/molecules/RecruitListView"
import { useInitializeAccountData } from "hooks/useInitializeAccountData"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { isInitializingFinishedState } from "recoils/initializingState"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
  isRecruitNotFoundState,
} from "recoils/isNotFoundState"
export const RecruitPage = () => {
  const [loading, asyncLoading] = useAsyncLoading("recruitIndex")
  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)
  const isRecruitNotFound = useRecoilValue(isRecruitNotFoundState)
  const navigate = useNavigate()
  const initialize = useInitializeAccountData()
  const isInitialized = useRecoilValue(isInitializingFinishedState)
  useEffect(() => {
    asyncLoading(initialize().catch((e) => console.warn(e.message)))
    // MEMO: 初回描画のみ実行する
  }, [])

  useEffect(() => {
    if (isInitialized && isRecruitNotFound) {
      navigate("/recruit/new")
    }
  }, [isInitialized])
  if (loading) {
    return <Spin />
  }
  return <RecruitListView />
}
